import { FormBase } from "core/components";

export default class TrackingCaseDocumentFieldValueEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "value",
                    label: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.EDIT.VALUE_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT_FIELD_VALUE.EDIT.VALUE_PLACEHOLDER"
                }
            ]
        };
    }
}